import React from "react";
import {useNavigate} from "react-router-dom";

import KeyValueHorizontal from "../../components/KeyValueHorizontal";
import {OverlayBox, OverlayContainer} from "../../components/OverlayBox";
import SummaryCard, {SummaryCardActions, SummaryCardStack} from "./SummaryCard";

import RequestsIcon from "@mui/icons-material/Email";
import {PieChart, mangoFusionPaletteLight} from "@mui/x-charts";
import grey from '@mui/material/colors/grey';
import Typography from "@mui/material/Typography";
import StyledToggleButtonGroup from "../../components/StyledToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";

const RequestsCard = ({requestsSummary}) => {
    const navigate = useNavigate();
    const [period, setPeriod] = React.useState("today"); // today, month, year

    const received = requestsSummary?.[period]?.received ?? 0;
    const filtered = requestsSummary?.[period]?.filtered ?? 0;
    const autoReplied = requestsSummary?.[period]?.autoReplied ?? 0;
    const sent = received - filtered - autoReplied;

    const pieWidth= 240;
    const pieRadius = 110;
    const colors = [
        mangoFusionPaletteLight[1],
        mangoFusionPaletteLight[7],
        mangoFusionPaletteLight[2]
    ];

    const pieChartData = received === 0 ?
        [{id: 0, value: 1, color: grey[200]}]
        : [
        {id: 0, value: sent, label: 'Inviate', color: colors[0]},
        {id: 1, value: autoReplied, label: 'Risposte automatiche', color: colors[1]},
        {id: 2, value: filtered, label: 'Filtrate', color: colors[2]}
    ]

    const handlePeriodChange = (e, v) => {
        if(v !== null){
            setPeriod(v);
        }
    }

    const autoReplyKey = "Risposte automatiche";
    const handleClick = (key) => {
        if (key === autoReplyKey){
            navigate("/main/quotes?created_by_auto_reply=true");
        }
    }

    return (
        <SummaryCard title="Richieste"
                     avatarColor={colors[2]}
                     AvatarIcon={RequestsIcon}>
            <SummaryCardStack spacing={3}>

                <StyledToggleButtonGroup
                    color="primary"
                    value={period}
                    exclusive
                    onChange={handlePeriodChange}
                    aria-label="Platform"
                    size="small"
                >
                    <ToggleButton value="today">Oggi</ToggleButton>
                    <ToggleButton value="month">Mese</ToggleButton>
                    <ToggleButton value="year">Anno</ToggleButton>
                </StyledToggleButtonGroup>

                <OverlayContainer sx={{display: "flex", justifyContent: "center"}}>
                    <PieChart series={[{
                        data: pieChartData,
                        innerRadius: 60,
                        outerRadius: pieRadius,
                        paddingAngle: 2,
                        cornerRadius: 5,
                        startAngle: -90,
                        endAngle: 90,
                        cx: pieRadius + 5, // +5 to center the pie
                        cy: pieRadius - 5, // -5 to center the pie
                    }]}
                              legend={{hidden: true, position: {vertical: 'bottom', horizontal: 'middle'}}}
                              width={pieWidth}
                              height={pieRadius}
                    />
                    <OverlayBox sx={{display: "flex", alignItems: "end", justifyContent: "center"}}>
                        <Typography variant="h4" sx={{width: pieWidth}} align="center" fontWeight={500}>
                            {received}
                        </Typography>
                    </OverlayBox>
                </OverlayContainer>

                <KeyValueHorizontal valueTextVariant="h5"
                                    keyTextVariant="body2"
                                    showKeyOnBottom={true}
                                    keyPadding={0}
                                    pairs={[
                                        ["Ricevute", sent],
                                        [autoReplyKey, autoReplied],
                                        ["Filtrate", filtered],
                                    ]}
                                    colors={colors}
                                    onClick={handleClick}
                />

            </SummaryCardStack>
            <SummaryCardActions/>
        </SummaryCard>
    )
};

export default RequestsCard;